import React, { Fragment, useState } from 'react';
import { RenderHeader, Columnz, DataTablez, TimeBody, Body, ActionBody, useGetParams } from "@/components/DataTable";
import { useListHistoryLog, useCountHistoryLog } from "../util";
import { Dropdownz, GridForm } from '@/components/ListForm';
import { useListUserV2 } from '@/modules/users/user/util';

const billStatuses = [
    { name: 'Chờ KH xác nhận', id: 3 },
    { name: 'KH đã xác nhận', id: 4 },
    { name: 'Đã duyệt', id: 1 },
]

const Header = (props) => {
    const { setParamsPaginator, paramsPaginator } = props
    const [filter, setFilter] = useState({});

    return (
        <GridForm paramsPaginator={paramsPaginator} setParamsPaginator={setParamsPaginator}
            filter={filter} setFilter={setFilter} className="lg:col-6" >
            <Dropdownz value={filter.status} options={billStatuses} placeholder="Trạng thái"
                onChange={(e) => setFilter({ ...filter, status: e.target.value })} />
        </GridForm>
    )
};

const HistoryLog = () => {
    const initParams = useGetParams()
    const [paramsPaginator, setParamsPaginator] = useState(initParams)
    const data = useListHistoryLog({ ...paramsPaginator, first: undefined });
    const totalRecords = useCountHistoryLog({ ...paramsPaginator, first: undefined });
    const users = useListUserV2();

    const header = RenderHeader({
        title: 'Lịch sử gửi thông báo OTP',
    });

    const CustomerBody = (e) => {
        if (e.info_customer) {
            try {
                const customer = JSON.parse(e.info_customer);
                return <span><b>{customer.full_name}</b>
                    {customer.phone ? <Fragment><br />{customer.phone}</Fragment> : ''}
                    {customer.email ? <Fragment><br />{customer.email}</Fragment> : ''}
                </span>
            } catch (err) { return '' }
        }
    }

    const StatusBody = (e) => {
        const status = billStatuses.find(s => s.id === e.status);
        return status ? status.name : e.status;
    }

    return (
        <div className="card">
            <Header paramsPaginator={paramsPaginator} setParamsPaginator={setParamsPaginator} />
            <DataTablez value={data} header={header}
                title="lịch sử gửi OTP" totalRecords={totalRecords}
                paramsPaginator={paramsPaginator} setParamsPaginator={setParamsPaginator} >
                <Columnz field="code" header="Mã hợp đồng" bodyStyle={{ minWidth: '10rem' }} />
                <Columnz body={CustomerBody} header="Khách hàng" bodyStyle={{ minWidth: '12rem' }} />
                <Columnz field="opt" header="Mã OTP" bodyStyle={{ minWidth: '8rem', fontWeight: 'bold', color: '#e74c3c', fontSize: '1.1rem' }} />
                <Columnz body={e => Body(users, e.user_sale_id)} header="NV Sale" bodyStyle={{ minWidth: '8rem' }} />
                <Columnz body={StatusBody} header="Trạng thái" bodyStyle={{ textAlign: 'center', minWidth: '8rem' }} />
                <Columnz header="Thời gian gửi" body={e => TimeBody(e.time_send_confirm)} bodyStyle={{ textAlign: 'center', minWidth: '10rem' }} />
                <Columnz header="Actions" body={(e) => ActionBody(e, '/contract/detail', undefined, paramsPaginator, setParamsPaginator)} bodyStyle={{ textAlign: 'center', minWidth: '7rem' }} />
            </DataTablez>
        </div>
    )
}

export default HistoryLog;
